import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsNaviKachelImplementieren(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      color="currentColor"
      data-name="Ebene 1"
      id="MS_Klimadashboard_Icons_Navi_Kachel-implementieren_svg__Ebene_1"
      viewBox="0 0 23.34 24.9"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.71 13.48H1c-.55 0-1 .45-1 1v5.5a4.93 4.93 0 0 0 4.92 4.92h4.79c.55 0 1-.45 1-1v-9.42c0-.55-.45-1-1-1Zm-1 9.42H4.92C3.31 22.9 2 21.59 2 19.98v-4.5h6.71v7.42ZM14.06 6.93h2.99v3.3c0 .55.45 1 1 1s1-.45 1-1v-3.3h2.99c.55 0 1-.45 1-1s-.45-1-1-1h-2.99v-3.3c0-.55-.45-1-1-1s-1 .45-1 1v3.3h-2.99c-.55 0-1 .45-1 1s.45 1 1 1ZM9.71 0H4.92A4.93 4.93 0 0 0 0 4.92v5.55c0 .55.45 1 1 1h8.71c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1Zm-1 9.47H2V4.92C2 3.31 3.31 2 4.92 2h3.79v7.47ZM22.34 13.48h-8.66c-.55 0-1 .45-1 1v9.42c0 .55.45 1 1 1h4.74a4.93 4.93 0 0 0 4.92-4.92v-5.5c0-.55-.45-1-1-1Zm-1 6.5c0 1.61-1.31 2.92-2.92 2.92h-3.74v-7.42h6.66v4.5Z" />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsNaviKachelImplementieren
